import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [servicesOpen, setServicesOpen] = useState(false);
  const [solutionsOpen, setSolutionsOpen] = useState(false);

  const servicesTimeoutRef = useRef(null);
  const solutionsTimeoutRef = useRef(null);

  const services = [
  { name: 'Cloud Migration', path: '/services/cloud-migration' },
  { name: 'Cloud Security & Compliance', path: '/services/cloud-security' },
  { name: 'Data & AI/ML Solutions', path: '/services/data-ai-ml' },
  { name: 'Cost Optimization', path: '/services/cost-optimization' },
  { name: 'AWS Managed Services', path: '/services/managed-services' },
  { name: 'DevOps Automation', path: '/services/devops' }];


  const solutions = [
  { name: 'E-commerce', path: '/solutions/ecommerce' },
  { name: 'FinTech', path: '/solutions/fintech' },
  { name: 'AI & Machine Learning', path: '/solutions/ai-ml' },
  { name: 'Manufacturing', path: '/solutions/manufacturing' }];


  const handleServicesMouseEnter = () => {
    if (servicesTimeoutRef.current) {
      clearTimeout(servicesTimeoutRef.current);
    }
    setServicesOpen(true);
  };

  const handleServicesMouseLeave = () => {
    servicesTimeoutRef.current = setTimeout(() => {
      setServicesOpen(false);
    }, 200);
  };

  const handleSolutionsMouseEnter = () => {
    if (solutionsTimeoutRef.current) {
      clearTimeout(solutionsTimeoutRef.current);
    }
    setSolutionsOpen(true);
  };

  const handleSolutionsMouseLeave = () => {
    solutionsTimeoutRef.current = setTimeout(() => {
      setSolutionsOpen(false);
    }, 200);
  };

  useEffect(() => {
    return () => {
      if (servicesTimeoutRef.current) {
        clearTimeout(servicesTimeoutRef.current);
      }
      if (solutionsTimeoutRef.current) {
        clearTimeout(solutionsTimeoutRef.current);
      }
    };
  }, []);

  return (
    <nav className="bg-[#020B1A] border-b border-cyan-500/20 shadow-lg fixed top-0 left-0 right-0 z-50" style={{ boxShadow: '0 4px 20px rgba(0, 212, 255, 0.1)' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center">
            <img
              src="/axora-logo.png"
              alt="Axora Cloud Service"
              className="h-10 w-auto !px-[2px] !rounded-[1px]"
              style={{ filter: 'drop-shadow(0 0 10px rgba(0, 212, 255, 0.3))' }} />

          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-300 hover:text-cyan-400 font-medium transition-colors">
              Home
            </Link>
            <Link to="/about" className="text-gray-300 hover:text-cyan-400 font-medium transition-colors">
              About Us
            </Link>
            
            <div
              className="relative"
              onMouseEnter={handleServicesMouseEnter}
              onMouseLeave={handleServicesMouseLeave}>

              <button className="flex items-center space-x-1 text-gray-300 hover:text-cyan-400 font-medium transition-colors">
                <span>Services</span>
                <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${servicesOpen ? 'rotate-180' : ''}`} />
              </button>
              
              <div
                className={`absolute top-full left-0 mt-1 w-64 bg-[#061426] rounded-lg shadow-2xl py-2 border border-cyan-500/30 transition-all duration-200 ${
                servicesOpen ?
                'opacity-100 visible translate-y-0' :
                'opacity-0 invisible -translate-y-2 pointer-events-none'}`
                }
                style={{ boxShadow: '0 8px 32px rgba(0, 212, 255, 0.2)' }}>

                {services.map((service, index) =>
                <Link
                  key={index}
                  to={service.path}
                  className="block px-4 py-2.5 text-gray-300 hover:bg-cyan-500/10 hover:text-cyan-400 transition-colors font-medium"
                  onClick={() => setServicesOpen(false)}>

                    {service.name}
                  </Link>
                )}
              </div>
            </div>

            <div
              className="relative"
              onMouseEnter={handleSolutionsMouseEnter}
              onMouseLeave={handleSolutionsMouseLeave}>

              <button className="flex items-center space-x-1 text-gray-300 hover:text-cyan-400 font-medium transition-colors">
                <span>Solutions</span>
                <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${solutionsOpen ? 'rotate-180' : ''}`} />
              </button>
              
              <div
                className={`absolute top-full left-0 mt-1 w-48 bg-[#061426] rounded-lg shadow-2xl py-2 border border-cyan-500/30 transition-all duration-200 ${
                solutionsOpen ?
                'opacity-100 visible translate-y-0' :
                'opacity-0 invisible -translate-y-2 pointer-events-none'}`
                }
                style={{ boxShadow: '0 8px 32px rgba(0, 212, 255, 0.2)' }}>

                {solutions.map((solution, index) =>
                <Link
                  key={index}
                  to={solution.path}
                  className="block px-4 py-2.5 text-gray-300 hover:bg-cyan-500/10 hover:text-cyan-400 transition-colors font-medium"
                  onClick={() => setSolutionsOpen(false)}>

                    {solution.name}
                  </Link>
                )}
              </div>
            </div>
          </div>

          <Link to="/contact">
            <Button className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 shadow h-9 py-2 bg-cyan-500 hover:bg-cyan-600 text-white font-medium px-6 transition-all duration-300" style={{ boxShadow: '0 0 20px rgba(0, 212, 255, 0.4)' }}>Business & Partnership Enquiries

            </Button>
          </Link>
        </div>
      </div>
    </nav>);

};

export default Navbar;